/* if you modify this file, please remove this line then fix eslint errors. */ /* eslint-disable */
import clipboardService from '../../../Services/clipboard';
import { translate } from '@openclassrooms/translations';

const clipboardCopyInit = () => {
  const elements = [...document.querySelectorAll('[data-component="clipboardCopy"]')];
  elements.forEach((element) => {
    const clipboardText = element.getAttribute('data-clipboard-text');
    clipboardService.enableCopyToElement(element, clipboardText);
    element.innerHTML = translate('global.action.copy_url');
    element.addEventListener('click', () => {
      element.innerHTML = translate('global.action.copy_url_done');
    });
  });
};

export default clipboardCopyInit;
